import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { createCostCenterArticleRangesTabPlugin } from '@mp/document-management/cost-center-article-ranges/cost-centers/feature';
import { CostCenterArticleRangesPermissions } from '@mp/document-management/cost-center-article-ranges/feature';
import { GroupedRequisitionsPermissions } from '@mp/document-management/grouped-requisitions/feature';
import { PurchaseRequisitionsPermissions } from '@mp/document-management/purchase-requisitions/feature';
import {
  DocumentManagementOrganizationSettingsPermissions,
  SupplierPurchaseRequisitionSettingsPermissions,
  createClinicSupplierPurchaseRequisitionsTabPlugin,
  createPurchaseRequisitionOrganizationSettingsPlugin,
} from '@mp/document-management/settings/feature';
import { COST_CENTER_DETAILS_TAB_PLUGIN } from '@mp/organization-master-data/cost-centers/cost-center-details-tab-plugin/util';
import { provideModuleInfo } from '@mp/shared/util';
import { provideModuleOrganizationSettings, provideModulePermissions } from '@mpk/shared/data-access';
import { CLINIC_SUPPLIER_DETAILS_TAB_PLUGIN } from '@mpsm/shared/util';

const moduleName = 'DocumentManagement';

export function provideDocumentManagementFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Belege',
    }),
    provideModulePermissions(
      moduleName,
      PurchaseRequisitionsPermissions,
      GroupedRequisitionsPermissions,
      DocumentManagementOrganizationSettingsPermissions,
      SupplierPurchaseRequisitionSettingsPermissions,
      CostCenterArticleRangesPermissions,
    ),
    makeEnvironmentProviders([
      {
        provide: CLINIC_SUPPLIER_DETAILS_TAB_PLUGIN,
        multi: true,
        useFactory: createClinicSupplierPurchaseRequisitionsTabPlugin,
      },
      {
        provide: COST_CENTER_DETAILS_TAB_PLUGIN,
        multi: true,
        useFactory: createCostCenterArticleRangesTabPlugin,
      },
    ]),
    provideModuleOrganizationSettings('Moduleinstellungen', createPurchaseRequisitionOrganizationSettingsPlugin),
  ];
}
